import { useState } from 'react';
import Input from '@/components/Input';
import useUpdateJobSource from '../../api/useUpdateJobSource';
import { showErrorToast, showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';
import LinkedAccountEditFieldModal from './LinkedAccountEditFieldModal';

type Props = {
  isOpen: boolean;
  jobSourceId: number;
  currentTitle: string;
  sourceLabel: string;
  onClose: () => void;
  onSaved: () => Promise<unknown>;
};

export default function LinkedAccountEditTitleModal({
  isOpen,
  jobSourceId,
  currentTitle,
  sourceLabel,
  onClose,
  onSaved,
}: Props) {
  const [title, setTitle] = useState(currentTitle);
  const updateJobSource = useUpdateJobSource();

  const handleSubmit = async () => {
    try {
      await updateJobSource.mutateAsync({ id: jobSourceId, title });
      await onSaved();
      showSuccessToast('タイトルを更新しました');
      onClose();
    } catch {
      showErrorToast('タイトルの更新に失敗しました');
    }
  };

  return (
    <LinkedAccountEditFieldModal
      isOpen={isOpen}
      title="タイトルを編集"
      isPending={updateJobSource.isPending}
      canSubmit={title.trim() !== ''}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col gap-xs">
        <label className="text-heading-xxs">{sourceLabel}</label>
        <Input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="h-[42px] w-full"
          disabled={updateJobSource.isPending}
        />
      </div>
    </LinkedAccountEditFieldModal>
  );
}
